import { feed as libraryFeed, IFeedConfiguration } from 'feed';
import { getRecommendations } from '~/actions/feed';
import {
  sampleCategories,
  sampleFeedCards,
  FEED_DEF_CONFIGURATION,
  FEED_MOBILE_DEF_CONFIGURATION,
} from '~/actions/feed/sample';
import RestServices from '~/api';
import { BaseResponse } from '~/api/data/BaseResponse';
import { clickstreamLogger } from '~/logging';
import { getCurrentPlatformType } from '~/utils/getCurrentPlatformType';

export class Demonstration {
  recommendations: IFeedCard[] = sampleFeedCards;
  categories: IItemMenuCategory[] = sampleCategories;
  reqRec: RequestRecommendationsFlag = 'off';

  currentFeedConfiguration = (configuration: IFeedConfiguration) => {
    const isMobileDevice = getCurrentPlatformType() === 'mobile';
    const defConfiguration = isMobileDevice ? FEED_MOBILE_DEF_CONFIGURATION : FEED_DEF_CONFIGURATION;

    return { ...defConfiguration, ...configuration };
  }

  /**
   * Отображает ленту по входным параметрам
   * @param feedParameters
   */
  demonstrationFeed = (feedId: string, selector: string, configuration: IFeedConfiguration) => {
    libraryFeed.killFeed(feedId);
    new libraryFeed.FeedCreator(
      feedId,
      selector,
      this.currentFeedConfiguration(configuration),
      this.recommendations,
      getCurrentPlatformType() === 'mobile',
      this.categories ?? [],
      this.categories[0]?.categoryId ?? ''
    ).start();
  }

  /**
   * Загружает ленту в статусе TEMP и вызывает метод запроса рекомендаций getRecommendations
   * @param feedId: string - идентификатор ленты
   */

  /**
   * Загружает ленту в статусе TEMP и вызывает метод запроса рекомендаций getRecommendations
   * 
   * @param feedId 
   * @param selector 
   * @returns 
   */
  fetchTempFeeds = async (feedId: string, selector: string): Promise<boolean> => {
    return RestServices.feedList
      .get('TEMP')
      .then((request: BaseResponse<Feed>) => {
        if (!request.errorData.errorFlag && request?.payload.length > 0) {
          libraryFeed.killFeed(feedId);
          getRecommendations({
            ...request.payload.find(feed => feed.feedId === feedId),
            selector,
            selectorMobile: selector,
          });

          return true;
        }

        clickstreamLogger.warn(`Feed: ${feedId} - проблемы при загрузке ленты TEMP, метод fetchTempFeedsAndCards`);

        return false;
      });
  }

  start = (feedParameters: IFeedParameters) => {
    window.clickstreamAnalyticUtilitiesDemo = {
      isDemo: true,
      hash: '',
    };
    const showDemoFeed = () => {
      this.demonstrationFeed(
        feedParameters.feedId,
        feedParameters.selector,
        feedParameters.configuration
          ? feedParameters.configuration as IFeedConfiguration
          : {
            countCardsInDisplay: 4,
          }
      );
    };
    if (this.reqRec !== 'temp') {
      showDemoFeed();

      return;
    }
    this.fetchTempFeeds(
      feedParameters.feedId,
      feedParameters.selector
    ).then((successfully) => {
      if (!successfully) showDemoFeed();
    });
  }
}
